// Area colors (populated via API)
export const AREA_COLORS = {};

export function applyAreaConfig(areasFromApi) {
  if (!areasFromApi || !Array.isArray(areasFromApi)) return;
  for (const k of areasFromApi) {
    AREA_COLORS[k.key] = { bg: k.bg, border: k.border_color || k.border, text: k.text_color || k.text };
  }
}

// Priorities
export const PRIOS = [
  { value: "critical", label: "Critical" },
  { value: "major", label: "Major" },
  { value: "highest", label: "Highest" },
  { value: "high", label: "High" },
  { value: "medium", label: "Medium" },
  { value: "low", label: "Low" },
  { value: "lowest", label: "Lowest" },
  { value: "minor", label: "Minor" },
  { value: "backlog", label: "Backlog" },
];

export const PRIO_ORDER = {
  critical: 0, major: 1, highest: 2, high: 3, medium: 4,
  low: 5, lowest: 6, minor: 7, backlog: 8,
};

// Localization (German month/day names for UI)
export const MONTH_NAMES = [
  "Januar", "Februar", "März", "April", "Mai", "Juni",
  "Juli", "August", "September", "Oktober", "November", "Dezember"
];

export const MONTHS_SHORT = [
  "Jan", "Feb", "Mär", "Apr", "Mai", "Jun",
  "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"
];

export const WEEKDAYS = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"];

// Default filters (central definition)
export const DEFAULT_FILTERS = {
  status: ["open"],
  person: [],
  prio: [],
  area: [],
};

// ---- Termin-Template-Muster — EINE Quelle für Kalender, Liste und Formular ----
// Kürzel: 2-5 Großbuchstaben/Umlaute/Ziffern. Muss zur Kürzel-Pflege in der
// Personalverwaltung passen (maxLength 5, nur toUpperCase) — die alte, verstreute
// [A-Z]{2,4}-Variante erkannte z.B. "MELBA Arbeit" oder "MÜ Office" nicht.
const ABBREV = "[A-ZÄÖÜ0-9]{2,5}";
// "AB Office", "AB Arbeit VM", "AB Urlaub", "Betriebsferien"
export const APPT_TEMPLATE_PATTERN = new RegExp(`^(${ABBREV}\\s+((?:Office|Arbeit)(?:\\s+(?:VM|NM))?|Urlaub)|Betriebsferien)$`);
// Ganztägige Urlaubs-Blöcke: "AB Urlaub" oder "Betriebsferien"
export const APPT_VACATION_BLOCK_PATTERN = new RegExp(`^(${ABBREV}\\s+Urlaub|Betriebsferien)$`);
// Alte individuelle "AB Urlaub"-Einträge (ausgeblendet — Urlaub läuft über Anträge)
export const APPT_INDIVIDUAL_VACATION_PATTERN = new RegExp(`^${ABBREV}\\s+Urlaub$`);
// Office/Arbeit-Template mit Capture-Gruppen (Kürzel, Typ, VM/NM) für die Tag-Kurzform
export const APPT_OFFICE_PATTERN = new RegExp(`^(${ABBREV})\\s+(Office|Arbeit)(?:\\s+(VM|NM))?$`);
// Personen-Template inkl. Urlaub, mit Captures (Kürzel, Typ) — fürs Termin-Formular
export const APPT_PERSON_TEMPLATE_PATTERN = new RegExp(`^(${ABBREV})\\s+((?:Office|Arbeit)(?:\\s+(?:VM|NM))?|Urlaub)$`);
